import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_USER_STATS_STATE = "userStats";
export const PATH_TO_COURSE_STATS_STATE = "courseStats";
export const PATH_TO_SECTION_STATS_STATE = "sectionStats";
export const PATH_TO_CONTENT_STATS_STATE = "contentStats";

const namespace = "seneca/studyStats/meta";

export const userStatsFetchStateConfig: CrudConfig = {
  name: "userStats",
  path: `${namespace}/${PATH_TO_USER_STATS_STATE}`,
  callTypes: [AllowedCallTypes.FETCH]
};

export const courseStatsFetchStateConfig: CrudConfig = {
  name: "courseStats",
  path: `${namespace}/${PATH_TO_COURSE_STATS_STATE}`,
  idFieldName: "courseId",
  callTypes: [AllowedCallTypes.FETCH, AllowedCallTypes.FETCH_ALL]
};

export const sectionStatsFetchStateConfig: CrudConfig = {
  name: "sectionStats",
  path: `${namespace}/${PATH_TO_SECTION_STATS_STATE}`,
  idFieldName: "courseId",
  callTypes: [AllowedCallTypes.FETCH]
};

export const contentStatsFetchStateConfig: CrudConfig = {
  name: "contentStats",
  path: `${namespace}/${PATH_TO_CONTENT_STATS_STATE}`,
  idFieldName: "courseId",
  callTypes: [AllowedCallTypes.FETCH]
};
